export default "__VITE_ASSET__f627ec30__"